import { useRef, useState } from "react";

// Browser MediaRecorder hook that records to webm/opus and returns a Blob.
export default function useVoiceRecorder() {
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    if (recording) return;
    setBusy(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, { mimeType: "audio/webm" });
      chunksRef.current = [];
      mr.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };
      mr.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
      };
      mr.start();
      mediaRef.current = mr;
      setRecording(true);
    } finally {
      setBusy(false);
    }
  };

  const stop = () =>
    new Promise((resolve) => {
      const mr = mediaRef.current;
      if (!mr) return resolve(null);
      mr.addEventListener(
        "stop",
        () => {
          const blob = new Blob(chunksRef.current, { type: "audio/webm" });
          mediaRef.current = null;
          setRecording(false);
          resolve(blob);
        },
        { once: true }
      );
      mr.stop();
    });

  return { recording, busy, start, stop };
}
